<template>
  <div class="container">
    <el-container>
      <el-main>
        <el-header>系统通知</el-header>
        <div >
          <div >
            <el-table
              :data="records"
              stripe
              :show-header="false"
              empty-text="暂无消息"
            >
              <el-table-column label="消息">
                <template slot-scope="scope">
                  <div style="display: flex">
                    <div v-html="scope.row.content">
                    </div>
                    <a href="javascript:void(0)" @click="toUrl(scope.row.route)">点击查看</a>
                  </div>

                </template>
              </el-table-column>
              <el-table-column width="200" label="通知时间" prop="createTime">
              </el-table-column>
            </el-table>
          </div>
          <div class="block" v-if="records.length>0">
            <el-pagination
              background
              @current-change="queryMessagePage"
              :current-page="page.current"
              :page-size="page.size"
              layout="prev, pager, next, jumper"
              :total="page.total">
            </el-pagination>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import api from '../../../api'
import {listSearchMixin} from '../../../config/mixin'
import {mapGetters, mapMutations} from 'vuex'

export default {
  mixins: [listSearchMixin],
  data(){
    return{
      keyword:'',
      records:[

      ],
      page:{
        current:1,
        size:8,
        tatal:0,
      }
    }
  },
  computed:{
    ...mapGetters([
      'userInfo' // 用户信息
    ])
  },
  created() {
    this.queryMessageRecords();
    this.read();
  },
  methods:{
    ...mapMutations({
      setInfoTotal: 'SET_INFOTOTAL'
    }),
    toOrderDetail (id) {
      this.$router.push({
        path: '/orderDetail',
        query: {
          orderId: id
        }
      })
    },

    toUrl(data){
      console.log(data)

      let param= JSON.parse(data);
      this.$router.push({
        path:param.url,
        query: param.query,
      })
    },
    queryMessagePage(e){
      this.page.current=e;
      this.queryFoot();
    },
    queryMessageRecords(){
      let self=this;
      let params = {
        url: api.messageRecords + "?page=" + self.page.current + '&size=' + self.page.size,
        method: 'GET',
        data: {
        }
      }
      self.sendReq(params, (res) => {
        self.records=res.data.content;
        self.page.total=res.data.totalElements;
      });
    },
    read(){
      let params = {
        url: api.messageRead,
        method: 'GET',
        data: {
        }
      }
      this.sendReq(params, (res) => {
        this.setInfoTotal(0);
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  border: 1px solid #E5E5E5;
  .el-row {
    width: 890px;
    margin-bottom: 20px;
    border-bottom: none !important;
    font-size: 15px;
    color: #99a9bf;
    padding-bottom: 10px;
  }
  .el-col {
    text-align: left !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/message/message.vue